import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const SolutionsOverview = () => {
  const industries = [
    {
      title: 'Healthcare & Life Sciences',
      icon: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z',
      description: 'Transform patient care with AI-powered diagnostics, electronic health records, and clinical decision support systems.',
      link: '/solutions/healthcare-life-sciences',
      stats: { label: 'Patient Outcomes', value: '40%' }
    },
    {
      title: 'Financial Services',
      icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
      description: 'Enhance security, automate compliance, and deliver personalized banking experiences with advanced AI solutions.',
      link: '/solutions/financial-services',
      stats: { label: 'Risk Reduction', value: '60%' }
    },
    {
      title: 'Manufacturing & Logistics',
      icon: 'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z',
      description: 'Optimize supply chains, enable predictive maintenance, and streamline operations with intelligent automation.',
      link: '/solutions/manufacturing-logistics',
      stats: { label: 'Efficiency Gain', value: '35%' }
    },
    {
      title: 'Retail & E-commerce',
      icon: 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z',
      description: 'Create personalized shopping experiences, optimize inventory, and boost sales with AI-driven insights.',
      link: '/solutions/retail-ecommerce',
      stats: { label: 'Revenue Growth', value: '45%' }
    },
    {
      title: 'Technology & Software',
      icon: 'M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4',
      description: 'Accelerate development cycles, enhance code quality, and deliver innovative products faster with AI tools.',
      link: '/solutions/technology-software',
      stats: { label: 'Time to Market', value: '50%' }
    },
    {
      title: 'Government & Public Sector',
      icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
      description: 'Modernize citizen services, improve operational efficiency, and enhance transparency with digital solutions.',
      link: '/solutions/government-public-sector',
      stats: { label: 'Service Speed', value: '55%' }
    },
    {
      title: 'Education & Training',
      icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
      description: 'Transform learning experiences with personalized AI tutors, adaptive learning platforms, and analytics.',
      link: '/solutions/education-training',
      stats: { label: 'Engagement', value: '70%' }
    },
    {
      title: 'Energy & Utilities',
      icon: 'M13 10V3L4 14h7v7l9-11h-7z',
      description: 'Optimize energy distribution, predict maintenance needs, and enable smart grid management with AI.',
      link: '/solutions/energy-utilities',
      stats: { label: 'Cost Savings', value: '30%' }
    },
    {
      title: 'Media & Entertainment',
      icon: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
      description: 'Deliver personalized content, automate production workflows, and engage audiences with AI-powered tools.',
      link: '/solutions/media-entertainment',
      stats: { label: 'User Retention', value: '65%' }
    },
    {
      title: 'Real Estate',
      icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
      description: 'Streamline property management, enhance client experiences, and optimize investments with smart solutions.',
      link: '/solutions/real-estate',
      stats: { label: 'Process Speed', value: '48%' }
    },
    {
      title: 'Telecommunications',
      icon: 'M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z',
      description: 'Improve network performance, enhance customer service, and predict maintenance with AI analytics.',
      link: '/solutions/telecommunications',
      stats: { label: 'Uptime', value: '99.9%' }
    },
    {
      title: 'Automotive',
      icon: 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
      description: 'Enable autonomous systems, optimize manufacturing, and enhance vehicle intelligence with AI technology.',
      link: '/solutions/automotive',
      stats: { label: 'Innovation', value: '2X' }
    }
  ];

  const capabilities = [
    {
      title: 'Industry Expertise',
      description: 'Deep domain knowledge and specialized solutions tailored to your industry challenges',
      icon: 'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z'
    },
    {
      title: 'Proven Methodology',
      description: 'Structured approach with validated frameworks for successful digital transformation',
      icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01'
    },
    {
      title: 'Scalable Solutions',
      description: 'Future-ready architectures designed to grow with your business needs',
      icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
    },
    {
      title: 'Regulatory Compliance',
      description: 'Built-in compliance with industry regulations and data protection standards',
      icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
    }
  ];

  return (
    <>
      <SEO 
        title="Industry Solutions - AI & Digital Transformation Across Sectors"
        description="Explore Abacies Logiciels' comprehensive industry solutions spanning healthcare, finance, manufacturing, retail, and more. Transform your sector with tailored AI and digital technology."
        keywords="industry solutions, healthcare AI, financial technology, manufacturing automation, retail solutions, government digital transformation, education technology"
      />

      {/* Hero Section */}
      <section className="hero-section py-10 bg-gradient-to-br from-pearl-white via-white to-alabaster">
        <div className="page-container">
          <div className="max-w-5xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Industry-Specific <span className="text-gradient">Solutions</span>
            </h1>
            <p className="text-xl text-titanium leading-relaxed mb-8 animate-slide-up">
              Transform your industry with tailored AI solutions and digital technologies designed to address your unique challenges and drive measurable business outcomes across every sector.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up" style={{ animationDelay: '0.1s' }}>
              <Link to="/contact" className="btn-primary">
                Discuss Your Industry
              </Link>
              <Link to="/ai-hub" className="btn-secondary">
                Explore AI Capabilities
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section className="py-5 bg-white border-y border-platinum">
        <div className="page-container">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl md:text-4xl font-bold text-primary-red mb-2">12+</div>
              <div className="text-sm text-titanium">Industries Served</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-primary-red mb-2">100+</div>
              <div className="text-sm text-titanium">Enterprise Clients</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-primary-red mb-2">20</div>
              <div className="text-sm text-titanium">Countries</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-primary-red mb-2">99%</div>
              <div className="text-sm text-titanium">Client Satisfaction</div>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-5 md:py-5 bg-alabaster">
        <div className="page-container">
          <div className="text-center mb-12">
            <h2 className="section-title">Solutions By Industry</h2>
            <p className="section-subtitle max-w-3xl mx-auto">
              Specialized expertise and proven solutions tailored to meet the unique demands of your industry
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {industries.map((industry, index) => (
              <Link 
                key={index}
                to={industry.link}
                className="group card hover:scale-105 transition-all duration-300"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="w-14 h-14 bg-blush-light/40 rounded-xl flex items-center justify-center group-hover:bg-primary-red/10 transition-colors duration-300">
                    <svg className="w-7 h-7 text-primary-red" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={industry.icon} />
                    </svg>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-titanium">{industry.stats.label}</div>
                    <div className="text-xl font-bold text-primary-red">{industry.stats.value}</div>
                  </div>
                </div>
                
                <h3 className="text-xl font-semibold mb-3 text-charcoal group-hover:text-primary-red transition-colors">
                  {industry.title}
                </h3>
                <p className="text-titanium mb-4 leading-relaxed">
                  {industry.description}
                </p>
                
                <span className="inline-flex items-center text-primary-red font-semibold group-hover:translate-x-2 transition-transform duration-300">
                  Explore Solutions
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section className="py-5 md:py-5 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="section-title">Our Solution Approach</h2>
            <p className="section-subtitle">
              A proven methodology that combines industry expertise with cutting-edge technology
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {capabilities.map((capability, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blush-light/40 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-primary-red" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={capability.icon} />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold mb-2 text-charcoal">{capability.title}</h3>
                <p className="text-sm text-titanium">{capability.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Common Challenges Section */}
      <section className="py-5 md:py-5 bg-gradient-to-br from-charcoal to-graphite text-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center">
              Common Industry Challenges We Solve
            </h2>
            <p className="text-xl text-pearl-white/80 mb-12 text-center">
              Regardless of your sector, these are the transformation challenges we help overcome
            </p>

            <div className="grid md:grid-cols-2 gap-6">
              {[
                {
                  challenge: 'Legacy System Modernization',
                  solution: 'Seamless migration to modern, scalable cloud-based architectures'
                },
                {
                  challenge: 'Data Silos & Integration',
                  solution: 'Unified data platforms with real-time integration across systems'
                },
                {
                  challenge: 'Manual Process Inefficiency',
                  solution: 'Intelligent automation reducing operational overhead by 60%'
                },
                {
                  challenge: 'Regulatory Compliance',
                  solution: 'Built-in compliance frameworks meeting industry standards'
                },
                {
                  challenge: 'Customer Experience Gap',
                  solution: 'AI-powered personalization driving engagement and loyalty'
                },
                {
                  challenge: 'Competitive Pressure',
                  solution: 'Innovation acceleration through advanced AI capabilities'
                }
              ].map((item, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 bg-primary-red/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <svg className="w-6 h-6 text-coral-mist" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-semibold mb-2 text-white">{item.challenge}</h3>
                      <p className="text-sm text-pearl-white/70">{item.solution}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Success Metrics */}
      <section className="py-5 md:py-5 bg-white">
        <div className="page-container">
          <div className="text-center mb-12">
            <h2 className="section-title">Measurable Business Impact</h2>
            <p className="section-subtitle max-w-3xl mx-auto">
              Real results delivered across industries through our transformation solutions
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {[
              { metric: '45%', label: 'Average Cost Reduction', description: 'Through process automation' },
              { metric: '3X', label: 'Faster Time to Market', description: 'For new products and features' },
              { metric: '60%', label: 'Improved Efficiency', description: 'In operational workflows' },
              { metric: '99.9%', label: 'System Reliability', description: 'Enterprise-grade uptime' }
            ].map((item, index) => (
              <div key={index} className="text-center card">
                <div className="text-4xl md:text-5xl font-bold text-primary-red mb-2">{item.metric}</div>
                <div className="font-semibold text-charcoal mb-2">{item.label}</div>
                <div className="text-sm text-titanium">{item.description}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technology Stack Showcase */}
      <section className="py-5 md:py-5 bg-alabaster">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="section-title">Technology Excellence</h2>
            <p className="section-subtitle">
              Leveraging cutting-edge technologies to deliver industry-leading solutions
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              {
                category: 'AI & Machine Learning',
                technologies: ['TensorFlow', 'PyTorch', 'Scikit-learn', 'Hugging Face', 'OpenAI']
              },
              {
                category: 'Cloud & Infrastructure',
                technologies: ['AWS', 'Azure', 'Google Cloud', 'Kubernetes', 'Docker']
              },
              {
                category: 'Data & Analytics',
                technologies: ['Apache Spark', 'Databricks', 'Snowflake', 'Power BI', 'Tableau']
              }
            ].map((stack, index) => (
              <div key={index} className="card">
                <h3 className="text-lg font-semibold mb-4 text-charcoal">{stack.category}</h3>
                <div className="flex flex-wrap gap-2">
                  {stack.technologies.map((tech, techIndex) => (
                    <span key={techIndex} className="px-3 py-1 bg-blush-light/30 text-primary-red text-sm rounded-full">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Implementation Process */}
      <section className="py-5 md:py-5 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="section-title">Our Implementation Process</h2>
            <p className="section-subtitle">
              A structured approach ensuring successful delivery and adoption
            </p>
          </div>

          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { step: '01', title: 'Discovery & Assessment', description: 'Deep dive into your business needs and technical landscape' },
                { step: '02', title: 'Solution Design', description: 'Architecting tailored solutions aligned with your goals' },
                { step: '03', title: 'Development & Testing', description: 'Agile implementation with continuous validation' },
                { step: '04', title: 'Deployment & Support', description: 'Seamless launch with ongoing optimization' }
              ].map((phase, index) => (
                <div key={index} className="relative">
                  <div className="card text-center hover:shadow-xl transition-shadow duration-300">
                    <div className="text-5xl font-bold text-primary-red/20 mb-3">{phase.step}</div>
                    <h3 className="font-semibold text-charcoal mb-2">{phase.title}</h3>
                    <p className="text-sm text-titanium">{phase.description}</p>
                  </div>
                  {index < 3 && (
                    <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2">
                      <svg className="w-6 h-6 text-primary-red" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-5 md:py-5 bg-primary-red text-white">
        <div className="page-container text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Ready to Transform Your Industry?
          </h2>
          <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
            Let's discuss how our industry-specific solutions can drive measurable results for your organization. Schedule a consultation with our experts today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="bg-white text-primary-red px-8 py-4 rounded-lg text-lg font-semibold hover:bg-pearl-white transition-all duration-300 shadow-lg">
              Schedule Consultation
            </Link>
            <Link to="/company/our-story" className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-primary-red transition-all duration-300">
              Learn About Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default SolutionsOverview;